import React, { useState } from "react";
import ConversationViewer from "./components/ConversationViewer";
import { MobileView } from "react-device-detect";
import LoadingFullScreen from "../../components/LoadingFullScreen";

const MobileConversationPage = (props: any) => {
  const { conversationId } = props.match.params;
  const [loading, setLoading] = useState<boolean>(false);
  return (
    <>
      {loading && <LoadingFullScreen />}
      <MobileView>
        <div className="messaging-container-mobile fade">
          <ConversationViewer conversationId={conversationId} setLoading={setLoading} />
        </div>
      </MobileView>
    </>
  );
};

export default MobileConversationPage;
